import { useQuery as useTopRetailersQuery } from "@faire/web-api--source/api/retailer/productToken/top-retailers/get-hooks";

interface IProps {
  productToken: string | undefined;
}

export const useTopRetailers = ({ productToken }: IProps) => {
  const { data } = useTopRetailersQuery(productToken ?? "", {
    enabled: !!productToken,
  });
  const online_retailers = data?.online_retailers ?? [];
  const brick_and_mortar_retailers = data?.brick_and_mortar_retailers ?? [];

  return {
    online_retailers,
    brick_and_mortar_retailers,
  };
};
